/**
 * Notifier module
 *
 * This module creates some notifications
 *
 */

'use strict';

const container = require('./../../core/container');
const jQuery = require('jquery');
const navigatorInfo = require('./../../services/navigator');

const tpl = require('./templates/notification.hbs');

/**
 * Create a new notification
 *
 * @param  {string} content
 * @param  {string} type warning | error | success | info
 * @param  {string} ico (optional) classname of an icon
 * @param  {string} classes
 */
const create = function(content, type, ico, classes) {
  let config = {
    content: content,
    type: type,
    ico: ico,
    classes: classes || '',
  };
  let transitionName = navigatorInfo.getTransition().end;
  let timer = 5000;
  let $notification = jQuery(tpl(config));
  let $toolbar = container.get('$toolbar');
  let $notifierWrapper = container.get('$notifierWrapper');

  if ($notifierWrapper === undefined) {
    $notifierWrapper = jQuery('<div id="cloud-notifier-wrapper"></div>');
    $notifierWrapper.insertAfter($toolbar);
    container.set('$notifierWrapper', $notifierWrapper);
  }

  $notifierWrapper.prepend($notification);
  setTimeout(function($notification, timer) {
    $notification.css('height', $notification.outerHeight()).addClass('animating');
    setTimeout(function($notification) {
      $notification.off(transitionName).one(transitionName, function() {
        jQuery(this).remove();
      });
      $notification.addClass('animating-out').css('height', 0);
    }.bind(undefined, $notification), timer + 20);
  }.bind(undefined, $notification, timer), 20);
};

/**
 * Create a warning notification
 * Shortcut of create function
 *
 * @param {string} content
 * @param {string} [ico] ico
 * @param {string} [classes] classes
 */
module.exports.warning = function(content, ico, classes) {
  create(content, 'warning', ico, classes);
};

/**
 * Create a error notification
 * Shortcut of create function
 *
 * @param {string} content
 * @param {string} [ico] ico
 * @param {string} [classes] classes
 */
module.exports.error = function(content, ico, classes) {
  create(content, 'error', ico, classes);
};

/**
 * Create a success notification
 * Shortcut of create function
 *
 * @param {string} content
 * @param {string} [ico] ico
 * @param {string} [classes] classes
 */
module.exports.success = function(content, ico, classes) {
  create(content, 'success', ico, classes);
};

/**
 * Create a info notification
 * Shortcut of create function
 *
 * @param {string} content
 * @param {string} [ico] ico
 * @param {string} [classes] classes
 */
module.exports.info = function(content, ico, classes) {
  create(content, 'info', ico, classes);
};
